import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => savedCallback.current();
    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
};

useInterval.defaultProps = {
  callback: () => {},
  delay: 0
};

useInterval.propTypes = {
  callback: PropTypes.func.isRequired,
  delay: PropTypes.number.isRequired
};

export default useInterval;
